import React from 'react';
import './Focused.scss';

export default function Focused() {

  return (
    <>
      <div className='focused-layer'>
        <div className="section-title-div">
          <h3 className='div-title'><span>E</span>DUCATION</h3>
          <div className="div-centered-text">
            Areas of Interest
          </div>
        </div>
        {/* <span>Things that I focus on</span> */}
        {/* <h3>What I focus on</h3> */}
        <div className='focus'>
          {/* https://icon-sets.iconify.design/?query=graph */}
          <div className='focuses focus1'>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M1 3v2h22l-.01-1.993A2 2 0 0 0 21 1H3a2.001 2.001 0 0 0-2 2Zm3 1a1 1 0 1 1 1-1a1 1 0 0 1-1 1Zm3 0a1 1 0 1 1 1-1a1.004 1.004 0 0 1-1 1Zm5 6a4 4 0 1 0 4 4h-4Z" /><path fill="currentColor" d="M1 6v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6Zm20 14H3V8h18Z" /></svg>
            <span>Web & Mobile App Development</span>
            {/* <span className='focuses-subtitle'>Front End / Back End</span> */}
          </div>

          <div className='focuses focus2'>
            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="4"><path d="M44 28H28v16h16V28ZM13 4l9 16H4l9-16Zm23 16a8 8 0 1 0 0-16a8 8 0 0 0 0 16Z" /><path stroke-linecap="round" d="m4 28l16 16m0-16L4 44" /></g></svg>
            <span>Game Development</span>
            {/* <span>Unity </span> */}
          </div>

          <div className='focuses focus3'>
            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32"><path fill="currentColor" d="M27 24a2.96 2.96 0 0 0-1.285.3l-4.3-4.3H18v2h2.586l3.715 3.715A2.966 2.966 0 0 0 24 27a3 3 0 1 0 3-3zm0 4a1 1 0 1 1 1-1a1 1 0 0 1-1 1zm0-15a2.995 2.995 0 0 0-2.816 2H18v2h6.184A2.995 2.995 0 1 0 27 13zm0 4a1 1 0 1 1 1-1a1 1 0 0 1-1 1zm0-15a3.003 3.003 0 0 0-3 3a2.966 2.966 0 0 0 .348 1.373L20.596 10H18v2h3.404l4.4-4.252A2.999 2.999 0 1 0 27 2zm0 4a1 1 0 1 1 1-1a1 1 0 0 1-1 1z" /><path fill="currentColor" d="M18 6h2V4h-2a3.976 3.976 0 0 0-3 1.382A3.976 3.976 0 0 0 12 4h-1a9.01 9.01 0 0 0-9 9v6a9.01 9.01 0 0 0 9 9h1a3.976 3.976 0 0 0 3-1.382A3.976 3.976 0 0 0 18 28h2v-2h-2a2.002 2.002 0 0 1-2-2V8a2.002 2.002 0 0 1 2-2Zm-6 20h-1a7.005 7.005 0 0 1-6.92-6H6v-2H4v-4h3a3.003 3.003 0 0 0 3-3V9H8v2a1 1 0 0 1-1 1H4.08A7.005 7.005 0 0 1 11 6h1a2.002 2.002 0 0 1 2 2v4h-2v2h2v4h-2a3.003 3.003 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h2v4a2.002 2.002 0 0 1-2 2Z" /></svg>
            <span>Machine Learning</span>
          </div>

          {/* <div className='focuses focus4'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M2 2h2v18h18v2H2V2m12 12.5L12 18H7.94l-2.02-3.5L7.94 11H12l2 3.5m.08-8L12.06 10H8L6 6.5L8 3h4.06l2.02 3.5m7.17 4L19.23 14h-4.04l-2.02-3.5L15.19 7h4.04l2.02 3.5Z" /></svg>
            <h3>Data Analysis</h3>
          </div> */}

          {/* database systems 
           natural language processing, 
            scientific computing
           programming languages
           
1: Front End Developer.
2: Back End Developer.
4: Web Developer.
: Mobile Developer.
          */}
        </div>
        {/* data science?
            software engineerig
            cloud  */}
      </div>
    </>
  )
}

// footer:
// logo (?)
// 2022 credits
// socials icons lang